{
  "typescaleTokens": {
    "auforumassurance": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "Montserrat",
        "Body": "Montserrat",
        "Button": "Montserrat"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "Montserrat",
        "Body": "Montserrat",
        "Button": "Montserrat"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "Montserrat",
        "Body": "Montserrat",
        "Button": "Montserrat"
      }
    },
    "dealt": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "DM Sans",
        "Body": "DM Sans",
        "Button": "DM Sans"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "DM Sans",
        "Body": "DM Sans",
        "Button": "DM Sans"
      }
    },
    "dougs": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "eina03-semibold",
        "Body": "open sans",
        "Button": "open sans"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "eina03-semibold",
        "Body": "open sans",
        "Button": "open sans"
      }
    },
    "indy": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "MartinaPlantijn",
        "Body": "suisse intl",
        "Button": "suisse intl"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "MartinaPlantijn",
        "Body": "suisse intl",
        "Button": "suisse intl"
      }
    },
    "jump": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "codec pro",
        "Body": "noto sans",
        "Button": "codec pro"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "codec pro",
        "Body": "noto sans",
        "Button": "codec pro"
      }
    },
    "legalplace": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      }
    },
    "legalstart": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "suisse intl",
        "Body": "bagoss standard",
        "Button": "bagoss standard"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "suisse intl",
        "Body": "bagoss standard",
        "Button": "bagoss standard"
      }
    },
    "light": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "13px",
        "line-height-110": "36px",
        "line-height-100": "34px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "24px",
        "line-height-40": "20px",
        "line-height-30": "17px",
        "line-height-20": "15px",
        "line-height-50": "22px",
        "line-height-120": "40px",
        "line-height-130": "56px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "48px",
        "size-90": "40px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "20px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "archivo",
        "Body": "inter",
        "Button": "inter"
      },
      "mobile": {
        "size-110": "42px",
        "size-100": "36px",
        "size-90": "32px",
        "size-80": "28px",
        "size-70": "24px",
        "size-60": "22px",
        "size-50": "20px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "15px",
        "size-10": "13px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "16px",
        "line-height-110": "36px",
        "line-height-100": "34px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "19px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "40px",
        "line-height-130": "56px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "4px",
        "paragraph-20": "6px",
        "paragraph-30": "12px",
        "paragraph-40": "16px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "archivo",
        "Body": "inter",
        "Button": "inter"
      }
    },
    "obat": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "13px",
        "line-height-110": "36px",
        "line-height-100": "34px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "24px",
        "line-height-40": "20px",
        "line-height-30": "17px",
        "line-height-20": "15px",
        "line-height-50": "22px",
        "line-height-120": "40px",
        "line-height-130": "56px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "48px",
        "size-90": "40px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "20px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "aeonik",
        "Body": "poppins",
        "Button": "poppins"
      },
      "mobile": {
        "size-110": "42px",
        "size-100": "36px",
        "size-90": "32px",
        "size-80": "28px",
        "size-70": "24px",
        "size-60": "22px",
        "size-50": "20px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "15px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "16px",
        "line-height-110": "36px",
        "line-height-100": "34px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "19px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "40px",
        "line-height-130": "56px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "-0.20000000298023224px",
        "letter-40": "-0.4000000059604645px",
        "letter-20": "-0.10000000149011612px",
        "paragraph-10": "4px",
        "paragraph-20": "6px",
        "paragraph-30": "12px",
        "paragraph-40": "16px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "aeonik",
        "Body": "poppins",
        "Button": "poppins"
      }
    },
    "phenix": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "helvetica neue",
        "Body": "helvetica neue",
        "Button": "helvetica neue"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "roboto",
        "Body": "helvetica neue",
        "Button": "helvetica neue"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "roboto",
        "Body": "helvetica neue",
        "Button": "helvetica neue"
      }
    },
    "previi": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "open sans",
        "Body": "open sans",
        "Button": "open sans"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "open sans",
        "Body": "open sans",
        "Button": "open sans"
      }
    },
    "propulse": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "mukta",
        "Body": "mukta",
        "Button": "mukta"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "mukta",
        "Body": "mukta",
        "Button": "mukta"
      }
    },
    "qonto": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "700",
        "letter-10": "-0.1px",
        "letter-30": "-0.8px",
        "letter-40": "-1px",
        "letter-20": "-0.5px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "manrope",
        "Body": "manrope",
        "Button": "manrope"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "0px",
        "letter-30": "0px",
        "letter-40": "0px",
        "letter-20": "0px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "manrope",
        "Body": "manrope",
        "Button": "manrope"
      }
    },
    "resco": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "Source Sans 3",
        "Body": "Source Sans 3",
        "Button": "Source Sans 3"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "Source Sans 3",
        "Body": "Source Sans 3",
        "Button": "Source Sans 3"
      }
    },
    "revital": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "20px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "poppins",
        "Body": "poppins",
        "Button": "poppins"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "poppins",
        "Body": "poppins",
        "Button": "poppins"
      }
    },
    "shine": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "value serif",
        "Body": "mabry pro",
        "Button": "mabry pro"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "value serif",
        "Body": "mabry pro",
        "Button": "mabry pro"
      }
    },
    "sidecare": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "fraunces",
        "Body": "satoshi",
        "Button": "satoshi"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "fraunces",
        "Body": "satoshi",
        "Button": "satoshi"
      }
    },
    "superindep": {
      "bo": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "15px",
        "size-20": "13px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "14px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "18px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "0px",
        "size-tagline": "0px",
        "Heading": "inter",
        "Body": "inter",
        "Button": "inter"
      },
      "desktop": {
        "size-110": "56px",
        "size-100": "44px",
        "size-90": "36px",
        "size-80": "32px",
        "size-70": "28px",
        "size-60": "24px",
        "size-50": "21px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "72px",
        "size-130": "88px",
        "size-input": "14px",
        "line-height-10": "12px",
        "line-height-110": "48px",
        "line-height-100": "44px",
        "line-height-90": "40px",
        "line-height-80": "36px",
        "line-height-70": "32px",
        "line-height-60": "28px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "16px",
        "line-height-50": "24px",
        "line-height-120": "56px",
        "line-height-130": "80px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "52px",
        "size-tagline": "52px",
        "Heading": "poppins",
        "Body": "poppins",
        "Button": "poppins"
      },
      "mobile": {
        "size-110": "40px",
        "size-100": "32px",
        "size-90": "28px",
        "size-80": "24px",
        "size-70": "22px",
        "size-60": "20px",
        "size-50": "19px",
        "size-40": "18px",
        "size-30": "16px",
        "size-20": "14px",
        "size-10": "12px",
        "size-120": "48px",
        "size-130": "64px",
        "size-input": "16px",
        "line-height-10": "14px",
        "line-height-110": "38px",
        "line-height-100": "35px",
        "line-height-90": "32px",
        "line-height-80": "30px",
        "line-height-70": "28px",
        "line-height-60": "26px",
        "line-height-40": "22px",
        "line-height-30": "20px",
        "line-height-20": "18px",
        "line-height-50": "24px",
        "line-height-120": "42px",
        "line-height-130": "60px",
        "weight-500": "500",
        "weight-400": "400",
        "weight-600": "600",
        "letter-10": "-0.20000000298023224px",
        "letter-30": "-0.800000011920929px",
        "letter-40": "-1.2000000476837158px",
        "letter-20": "-0.4000000059604645px",
        "paragraph-10": "2px",
        "paragraph-20": "4px",
        "paragraph-30": "8px",
        "paragraph-40": "12px",
        "line-height-tagline": "32px",
        "size-tagline": "32px",
        "Heading": "poppins",
        "Body": "poppins",
        "Button": "poppins"
      }
    }
  }
}
